import { Component, OnInit } from '@angular/core';
import { animateFactory } from 'ng2-animate';




@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.css']
})
export class EmpresaComponent implements OnInit {
  trigger_state_name = 'off';
  estado: boolean = true;

  constructor() { }

  ngOnInit() {
  }

  cambiaEstado2() {

    console.log('In Cambia Estado --> ' + this.trigger_state_name );
    if (this.estado) {
      this.trigger_state_name = 'off';
      this.estado = false;
    }else {
      this.trigger_state_name = 'in';
      this.estado = true;
    }
  }

}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/empresa/empresa.component.ts